export function scrollToTop() {
  if (!import.meta.client) return;
  window.scrollTo({
    top: 0,
    behavior: "smooth", // Optional for smooth scrolling
  });
}

/**
 *
 * @param consentCookie `OptanonConsent` Cookie Injected By OneTrust
 * @returns `null` or, Mapping of consent group to status (1 means accepted) and Array of accepted groups
 * @example consentGroups => { C0001: '1', C0002: '0', C0003: '1', C0004: '1'}
 * acceptedGroups => ["C0001", "C0002", "C0004"]
 */
export function extractConsentGroups(consentCookie: string) {
  const decodedCookie = Object.fromEntries(
    new URLSearchParams(consentCookie)
  ).groups;
  if(!decodedCookie) return null;
  const consentGroups = decodedCookie.split(",").reduce((obj, item) => {
    const [key, value] = item.split(":");
    obj[key] = value;
    return obj;
  }, {} as Record<string, string>);
  const acceptedGroups = Object.keys(consentGroups).filter(
    (key) => consentGroups[key] === "1"
  );
  return { consentGroups, acceptedGroups };
}

export function getBrowser() {
  if(!import.meta.client) return "server";
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes("crios")) {
    return "chrome-ios"; // Chrome on iPhone
  } else if (userAgent.includes("fxios")) {
    return "firefox-ios"; // Firefox on iPhone
  } else if (userAgent.includes("edgios")) {
    return "edge-ios"; // Edge on iPhone
  } else if (userAgent.includes("safari") && !userAgent.includes("chrome")) {
    return "safari"; // Real Safari
  } else if (userAgent.includes("chrome") && !userAgent.includes("edg") && !userAgent.includes("opr")) {
    return "chrome";
  } else if (userAgent.includes("firefox")) {
    return "firefox";
  } else if (userAgent.includes("edg")) {
    return "edge";
  } else {
    return "other";
  }
}
